import {
    FETCH_MERCHANT_PAGE_CONTENT_SUCCESS,
    FETCH_MERCHANT_PAGE_CONTENT_FAILURE, FETCH_YELP_IMAGES_FOR_MERCHANTS, FETCH_YELP_IMAGES_FOR_MERCHANTS_RESET,
    UPLOAD_YELP_IMAGE_TO_S3, RESET_UPLOAD_YELP_IMAGE_TO_S3, SET_MERCHANT_CONTENT, IS_YELP_IMAGE_OK,
    IS_YELP_IMAGE_OK_RESET, GET_MERCHANT_ONBOARDING_CONTENT, GET_MERCHANT_ONBOARDING_CONTENT_RESET,
    POST_MERCHANT_ONBOARDING_PARTNER_FORM, POST_MERCHANT_ONBOARDING_PARTNER_FORM_RESET,
    GET_MERCHANT_DEAL_LOCATIONS_RESET, GET_MERCHANT_DEAL_LOCATIONS,
    GET_MERCHANT_DEALS_BY_LOCATION_RESET, GET_MERCHANT_DEALS_BY_LOCATION, REDEEM_MERCHANT_DEAL, REDEEM_MERCHANT_DEAL_RESET,
    GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT, GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT_RESET
} from '../actions/merchant';

const initialState = {
    fetchMerchantPageContent: {},
    fetchMerchantPageContentSuccess: null,
    fetchMerchantPageContentFailure: null,
    merchantIds: [],
    yelpMerchantImages: [],
    fetchYelpImagesForMerchantsSuccess: null,
    fetchYelpImagesForMerchantsError: null,
    yelpImageUrl: null,
    yelpImageError: null,
    yelpImageOk: null,
    yelpImageOkError: null,
    getMerchantOnboardingContentSuccess: null,
    getMerchantOnboardingContentError: null,
    merchantOnboardingContent: {},
    postMerchantOnboardingPartnerFormSuccess: null,
    postMerchantOnboardingPartnerFormError: null,
    merchantDealLocations: [],
    getMerchantDealLocationsSuccess: null,
    getMerchantDealLocationsError: null,
    merchantDeals: [],
    getMerchantDealsByLocationSuccess: null,
    getMerchantDealsByLocationError: null,
    redeemMerchantDealSuccess: null,
    redeemMerchantDealError: null,
    redeemMerchantDealResponse: null,
    redeemMerchantDealErrorObject: {},
    getAccessDevelopmentMerchantCountSuccess: null,
    getAccessDevelopmentMerchantCountError: null,
    accessDevelopmentMerchantCount: null
};

export default function merchantReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT:
            return {
                ...state,
                ...(action.meta.sent && {
                    getAccessDevelopmentMerchantCountSuccess: true,
                    accessDevelopmentMerchantCount: action.payload
                }),
                getAccessDevelopmentMerchantCountError: action.error
            };
        case GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT_RESET:
            return {
                ...state,
                getAccessDevelopmentMerchantCountSuccess: initialState.getAccessDevelopmentMerchantCountSuccess,
                getAccessDevelopmentMerchantCountError: initialState.getAccessDevelopmentMerchantCountError,
            };
        case REDEEM_MERCHANT_DEAL:
            return {
                ...state,
                ...(action.meta.sent && {
                    redeemMerchantDealSuccess: true,
                    redeemMerchantDealResponse: action.payload
                }),
                redeemMerchantDealError: action.error,
                ...(action.error && {
                    redeemMerchantDealErrorObject: action.payload
                })
            };
        case REDEEM_MERCHANT_DEAL_RESET:
            return {
                ...state,
                redeemMerchantDealSuccess: initialState.redeemMerchantDealSuccess,
                redeemMerchantDealError: initialState.redeemMerchantDealError,
                redeemMerchantDealErrorObject: initialState.redeemMerchantDealErrorObject
            };
        case GET_MERCHANT_DEAL_LOCATIONS:
            return {
                ...state,
                ...(action.meta.sent && {
                    getMerchantDealLocationsSuccess: true,
                    merchantDealLocations: action.payload.locations
                }),
                getMerchantDealLocationsError: action.error,
            };
        case GET_MERCHANT_DEAL_LOCATIONS_RESET:
            return {
                ...state,
                getMerchantDealLocationsSuccess: initialState.getMerchantDealLocationsSuccess,
                getMerchantDealLocationsError: initialState.getMerchantDealLocationsError,
            };
        case GET_MERCHANT_DEALS_BY_LOCATION:
            return {
                ...state,
                ...(action.meta.sent && {
                    getMerchantDealsByLocationSuccess: true,
                    merchantDeals: action.payload.offers || []
                }),
                getMerchantDealsByLocationError: action.error,
            };
        case GET_MERCHANT_DEALS_BY_LOCATION_RESET:
            return {
                ...state,
                getMerchantDealsByLocationSuccess: initialState.getMerchantDealsByLocationSuccess,
                getMerchantDealsByLocationError: initialState.getMerchantDealsByLocationError,
            };
        case FETCH_MERCHANT_PAGE_CONTENT_SUCCESS:
            return {
                ...state,
                fetchMerchantPageContent: action.data,
                fetchMerchantPageContentSuccess: true,
                fetchMerchantPageContentFailure: state.fetchMerchantPageContentFailure,
            };
        case FETCH_MERCHANT_PAGE_CONTENT_FAILURE:
            return {
                ...state,
                fetchMerchantPageContentFailure: true,
                fetchMerchantPageContentSuccess: state.fetchMerchantPageContentSuccess,
            };
        case FETCH_YELP_IMAGES_FOR_MERCHANTS:
            return {
                ...state,
                ...(action.meta.success && {
                    fetchYelpImagesForMerchantsSuccess: true,
                    yelpMerchantImages: action.payload
                }),
                fetchYelpImagesForMerchantsError: action.error,
                error: action.error
            };
        case FETCH_YELP_IMAGES_FOR_MERCHANTS_RESET:
            return {
                ...state,
                fetchYelpImagesForMerchantsSuccess: initialState.fetchYelpImagesForMerchantsSuccess,
                fetchYelpImagesForMerchantsError: initialState.fetchYelpImagesForMerchantsError,
            };
        case IS_YELP_IMAGE_OK:
            return {
                ...state,
                ...(action.meta.sent && { yelpImageOk: true }),
                yelpImageOkError: action.error
            };
        case IS_YELP_IMAGE_OK_RESET:
            return {
                ...state,
                yelpImageOk: initialState.yelpImageOk,
                yelpImageOkError: initialState.yelpImageOkError
            };
        case UPLOAD_YELP_IMAGE_TO_S3:
            return {
                ...state,
                yelpImageUrl: action.payload.url,
                yelpImageError: action.error
            };
        case RESET_UPLOAD_YELP_IMAGE_TO_S3:
            return {
                ...state,
                yelpImageUrl: state.yelpImageUrl,
                yelpImageError: state.yelpImageError
            };
        case SET_MERCHANT_CONTENT:
            return {
                ...state,
                fetchMerchantPageContent: action.data
            };
        case GET_MERCHANT_ONBOARDING_CONTENT:
            return {
                ...state,
                ...(action.meta && action.meta.sent && {
                    merchantOnboardingContent: action.payload,
                    getMerchantOnboardingContentSuccess: true
                }),
                getMerchantOnboardingContentError: action.error
            };
        case GET_MERCHANT_ONBOARDING_CONTENT_RESET:
            return {
                ...state,
                getMerchantOnboardingContentError: initialState.getMerchantOnboardingContentError,
                getMerchantOnboardingContentSuccess: initialState.getMerchantOnboardingContentSuccess
            };
        case POST_MERCHANT_ONBOARDING_PARTNER_FORM:
            return {
                ...state,
                ...(action.meta && action.meta.sent && {
                    postMerchantOnboardingPartnerFormSuccess: true
                }),
                postMerchantOnboardingPartnerFormError: action.error
            };
        case POST_MERCHANT_ONBOARDING_PARTNER_FORM_RESET:
            return {
                ...state,
                postMerchantOnboardingPartnerFormError: initialState.postMerchantOnboardingPartnerFormError,
                postMerchantOnboardingPartnerFormSuccess: initialState.postMerchantOnboardingPartnerFormSuccess
            };
        default:
            return state;
    }
}